//Oficina
//export const API = "http://172.16.9.75:8000/api";

// Casa
//export const API = "http://192.168.68.103:8000/api";

//Producción
export const API = "https://reaccionback.skyangel.com.mx/api";